import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function ConfirmUtilidadResult() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const status = (params.get("status") || "pending").toLowerCase();
  const partner = params.get("partner") || "";
  const tipo = params.get("tipo") || "";
  const proyecto = params.get("proyecto") || "";

  const ui = useMemo(() => {
    switch (status) {
      case "confirmed":
        return { title: "¡Gracias!", text: "Tu utilidad quedó registrada como Aceptada.", cls: "alert alert-success" };
      case "declined":
        return { title: "Gracias", text: "Has rechazado la utilidad asignada.", cls: "alert alert-warning" };
      case "invalid":
        return { title: "Enlace inválido", text: "El enlace no es válido o expiró. Contacta a LSSI Fin.", cls: "alert alert-danger" };
      default:
        return { title: "Estado desconocido", text: "No pudimos determinar el estado.", cls: "alert alert-secondary" };
    }
  }, [status]);

  return (
    <div className="container" style={{ maxWidth: 640, paddingTop: 32 }}>
      <div className={ui.cls} role="alert">
        <h4 className="alert-heading">{ui.title}</h4>
        <p className="mb-2">{ui.text}</p>
        {(partner || tipo || proyecto) && (
          <div style={{ fontSize: "0.9em", color: "#374151", marginTop: 12 }}>
            {partner && <div><strong>Partner:</strong> {partner}</div>}
            {tipo && <div><strong>Etapa:</strong> {tipo}</div>}
            {proyecto && <div><strong>Proyecto:</strong> {proyecto}</div>}
          </div>
        )}
      </div>
    </div>
  );
}
